// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eliteliga-datacenter{margin-bottom:1.5rem;max-width:100vw}@media (min-width: 768px){.eliteliga-datacenter{padding-left:1rem;padding-right:1rem;max-width:663px}}@media (min-width: 1024px){.eliteliga-datacenter{padding-left:1.5rem;padding-right:1.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
